import { PremiumEventHisotryModel } from "./premium.event.history.model";

export class PagedPremiumEventHistoryModel{
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: PremiumEventHisotryModel[] =[];
}